module.exports = __webpack_public_path__ + "img/nfc-slash.4d79ca7c.svg";